import axios from "axios";
import {URLAPISUBIDA, URLCARPETADESTINO} from "./Contantes";

export const subirMultiplesImagenHostingFile = (files = []) => {


    let arrPromesas = []

    for (let i = 0; i < files.length; i++) {
        arrPromesas.push(subirImagen(files[i], i))

    }

    return Promise.all(arrPromesas).then((dox) => {
        return {res: true, data: dox}
    })


}

const subirImagen = (file, i) => {

    return new Promise(resolve => {


        if (!file) {
            return resolve(file)
        }

        if (typeof file === 'string') {
            return resolve(file)

        } else {

            file.name = file.name + i

            const formData = new FormData();
            formData.append('img', file);

            axios.post(URLAPISUBIDA, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    return resolve(URLCARPETADESTINO + response.data.file_path)
                    // Handle successful upload response
                })
                .catch(error => {
                    return resolve(error.message)
                });


        }
    })
}
